import React from 'react';
import DownloadLink from '@hubins/components/DownloadLink';
import PreviewLink from '@hubins/components/PreviewLink';
import Heading from '@hubins/components/Heading';
import SimpleTable from 'modules/Tables/SimpleTable';
import './index.scss';

const headers = [
  { Header: '', accessor: 'fileName' },
  { Header: '', accessor: 'tools', width: 30 },
];

type Props = {
  documents: any[],
  auth?: boolean,
  title?: string,
  compact?: boolean,
  className?: string,
}

const DocumentsList = ({ documents, auth = true, title, compact, className = '' }: Props) => {

  const renderList = () => {
    if (!documents || documents.length === 0) {
      return [];
    }

    return documents.map((document, index) => {
      const url = `/v1/fa/${auth ? '' : 'unauth/'}documents/download/${document.fullPath.substring(1)}`;

      return (
        {
          fileName: document.fileName,
          tools: (
            <div className="documents__tools">
              <DownloadLink
                key={`download-${index}`}
                onlyIcon={true}
                hideName={true}
                name={document.fileName}
                url={url}
                icon="Common File Stack by Streamlinehq"
              />
              <PreviewLink
                key={`preview-${index}`}
                onlyIcon={true}
                hideName={true}
                name={document.fileName}
                url={url}
                icon="View 1 by Streamlinehq"
              />
            </div>
          ),
        }
      );
    });
  };

  return (
    <div className={compact ? '' : `documents ${className}`}>
      {title &&
        <Heading size="3" className="s-bottom-m s-top-m">
          {title}
        </Heading>
      }
      <SimpleTable
        headers={headers}
        data={renderList()}
      />
    </div>
  );
};

export default DocumentsList;
